import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import Icon from "./image.svg";

class LSAddImg extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add("ls_addimg", (locale) => {
            const button = new ButtonView(locale);

            button.set({
                label: "Ajouter une image",
                icon: Icon,
                tooltip: true,
                class: "ck-button-upload-library",
            });
            // Affichage de la fenêtre de sélection des images à l'exécution
            this.listenTo(button, "execute", () => {
                // Event custom qui retourne l'instance de l'éditeur.
                const event = new CustomEvent("ckAddImg", {
                    detail: {
                        editor: editor,
                        UploadLibraryForm: 1,
                    },
                });
                document.dispatchEvent(event);
            });
            return button;
        });
    }
}

export default LSAddImg;
